import {
  throwMovedAgentNativeModule,
  type DeprecatedExport,
} from "../../package-lifecycle/upgrade-error.js";

throwMovedAgentNativeModule(
  "@agent-native/core/client/components/ui/dialog",
  "@agent-native/toolkit/ui/dialog",
);

/** @deprecated @agent-native/core/client/components/ui/dialog moved to @agent-native/toolkit/ui/dialog. Run: npx @agent-native/core@latest upgrade --codemods */
export const Dialog =
  undefined as DeprecatedExport<"@agent-native/core/client/components/ui/dialog moved to @agent-native/toolkit/ui/dialog. Run: npx @agent-native/core@latest upgrade --codemods">;

/** @deprecated @agent-native/core/client/components/ui/dialog moved to @agent-native/toolkit/ui/dialog. Run: npx @agent-native/core@latest upgrade --codemods */
export const DialogClose =
  undefined as DeprecatedExport<"@agent-native/core/client/components/ui/dialog moved to @agent-native/toolkit/ui/dialog. Run: npx @agent-native/core@latest upgrade --codemods">;

/** @deprecated @agent-native/core/client/components/ui/dialog moved to @agent-native/toolkit/ui/dialog. Run: npx @agent-native/core@latest upgrade --codemods */
export const DialogContent =
  undefined as DeprecatedExport<"@agent-native/core/client/components/ui/dialog moved to @agent-native/toolkit/ui/dialog. Run: npx @agent-native/core@latest upgrade --codemods">;

/** @deprecated @agent-native/core/client/components/ui/dialog moved to @agent-native/toolkit/ui/dialog. Run: npx @agent-native/core@latest upgrade --codemods */
export const DialogDescription =
  undefined as DeprecatedExport<"@agent-native/core/client/components/ui/dialog moved to @agent-native/toolkit/ui/dialog. Run: npx @agent-native/core@latest upgrade --codemods">;

/** @deprecated @agent-native/core/client/components/ui/dialog moved to @agent-native/toolkit/ui/dialog. Run: npx @agent-native/core@latest upgrade --codemods */
export const DialogFooter =
  undefined as DeprecatedExport<"@agent-native/core/client/components/ui/dialog moved to @agent-native/toolkit/ui/dialog. Run: npx @agent-native/core@latest upgrade --codemods">;

/** @deprecated @agent-native/core/client/components/ui/dialog moved to @agent-native/toolkit/ui/dialog. Run: npx @agent-native/core@latest upgrade --codemods */
export const DialogHeader =
  undefined as DeprecatedExport<"@agent-native/core/client/components/ui/dialog moved to @agent-native/toolkit/ui/dialog. Run: npx @agent-native/core@latest upgrade --codemods">;

/** @deprecated @agent-native/core/client/components/ui/dialog moved to @agent-native/toolkit/ui/dialog. Run: npx @agent-native/core@latest upgrade --codemods */
export const DialogOverlay =
  undefined as DeprecatedExport<"@agent-native/core/client/components/ui/dialog moved to @agent-native/toolkit/ui/dialog. Run: npx @agent-native/core@latest upgrade --codemods">;

/** @deprecated @agent-native/core/client/components/ui/dialog moved to @agent-native/toolkit/ui/dialog. Run: npx @agent-native/core@latest upgrade --codemods */
export const DialogPortal =
  undefined as DeprecatedExport<"@agent-native/core/client/components/ui/dialog moved to @agent-native/toolkit/ui/dialog. Run: npx @agent-native/core@latest upgrade --codemods">;

/** @deprecated @agent-native/core/client/components/ui/dialog moved to @agent-native/toolkit/ui/dialog. Run: npx @agent-native/core@latest upgrade --codemods */
export const DialogTitle =
  undefined as DeprecatedExport<"@agent-native/core/client/components/ui/dialog moved to @agent-native/toolkit/ui/dialog. Run: npx @agent-native/core@latest upgrade --codemods">;

/** @deprecated @agent-native/core/client/components/ui/dialog moved to @agent-native/toolkit/ui/dialog. Run: npx @agent-native/core@latest upgrade --codemods */
export const DialogTrigger =
  undefined as DeprecatedExport<"@agent-native/core/client/components/ui/dialog moved to @agent-native/toolkit/ui/dialog. Run: npx @agent-native/core@latest upgrade --codemods">;
